module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<li class=\"page-list ")
    ; __append(escapeFn(id))
    ; __append("\">\r\n    ")
    ;  if (isFilter ){ 
    ; __append("\r\n        <a href=\"#\" data-target=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" style=\"color:var(--main-primary);font-weight: bold\" data-selected-key=\"page_instance\">\r\n            <i class=\"fa pf-carot-left pf-rotate-icon\" aria-expanded=\"true\"></i>\r\n        </a>\r\n    ")
    ; }else{
    ; __append("\r\n        <a href=\"#\" data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" data-selected-key=\"page_instance\">\r\n            <span data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"glyphicon glyphicon-triangle-right field-list-toggle\" data-selected-key=\"page_instance\"></span>\r\n        </a>\r\n    ")
    ; }
    ; __append("\r\n    ")
    ;  if (isFilter ){ 
    ; __append("\r\n        <a href=\"#\" data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" style=\"color:var(--main-primary);font-weight: bold\" data-selected-key=\"page_instance\">\r\n            ")
    ; __append(escapeFn(name))
    ; __append("</a>\r\n    ")
    ; } else{
    ; __append("\r\n        <a href=\"#\" data-target=\"")
    ; __append(escapeFn(id))
    ; __append("\" class=\"field-list-toggle\" data-selected-key=\"page_instance\">\r\n            <i class=\"page-icon fa fa-file-text-o\" alt=\"page icon\" style=\"height: 20px;\r\n            width: 20px;\r\n            margin-right: 0;\r\n            font-family: 'FontAwesome' !important;\r\n            font-size: 1.5em !important;\r\n            padding-top: 2px;\"></i>\r\n            ")
    ; __append(escapeFn(name))
    ; __append("\r\n        </a>\r\n    ")
    ; }
    ; __append("\r\n    <ul class=\"control-list ")
    ; __append(escapeFn(id))
    ; __append("\" id=\"control-list-")
    ; __append(escapeFn(id))
    ; __append("\" style=\"display: none;\">\r\n        ")
    ; 
        selectFields.map(function(selectValue, selectValueId) {
        
    ; __append("\r\n        <li style=\"padding-left: 1.3em\">\r\n            <a href=\"#\" class=\"field-select\" id=\"field-select-")
    ; __append(escapeFn(id))
    ; __append("-")
    ; __append(escapeFn(selectValue.text.toString().replace(/\s/g, '') ))
    ; __append("\"\r\n               data-selected-item=\"")
    ; __append(escapeFn(id ))
    ; __append("-")
    ; __append(escapeFn(selectValue.text.replace(/\s/g, '') ))
    ; __append("\"\r\n               data-selected-name=\"")
    ; __append(escapeFn(name))
    ; __append(" - ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\"\r\n               data-selected-key=\"")
    ; __append(escapeFn(selectValue.factoryKey))
    ; __append("\">\r\n                <i class=\"page-icon fa fa-file-text-o\" alt=\"page icon\" style=\"height: 20px;\r\n                width: 20px;\r\n                margin-right: 0;\r\n                font-family: 'FontAwesome' !important;\r\n                font-size: 1.5em !important;\r\n                padding-top: 2px;\"></i>\r\n                ")
    ; __append(escapeFn(selectValue.text))
    ; __append("\r\n            </a>\r\n        </li>\r\n        ")
    ; 
        })
        
    ; __append("\r\n    </ul>\r\n</li>\r\n")
  }
  return __output;

}